<template>
  <div class="tile is-parent is-vertical">
    <article class="tile is-child formbox">
      <button
        id="feedbackbutton"
        class="button feedbackbutton"
        @click="redacaoInfo(redacao.id), isCardModalActive3 = true"
      >
        Enviar Feedback
        <b-icon icon="pencil"></b-icon>
      </button>
      <form @submit.prevent="validate">
        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button id="updatebutton" type="submit" class="button updatebutton" disabled>
            {{buttom}}
            <b-icon v-if="(progress === 100)" class="icon-enviar" />
            <span v-else>{{ progress }}%</span>
          </button>
        </div>

        <b-field
          class="criterios"
          v-for="criterio in redacao.criterios"
          :key="criterio.nome"
          :label="criterio.descricao"
          :type="{'is-danger': errors.has(criterio.nome)}"
          :message="errors.first(criterio.nome)"
        >
          <b-select
            :placeholder="`Selecione a nota de ${criterio.nome}`"
            icon="file-document"
            expanded
            v-model="correcao.notas[criterio.id]"
            v-validate="'required'"
            :name="criterio.nome"
          >
            <option v-for="(nota, index) in notas(criterio)" v-bind:key="index" :value="nota">{{ nota }}</option>
          </b-select>
        </b-field>

        <b-field id="b-nota-final" class="column is-12" label="Nota final:">
          <span>{{notaFinal}}</span>
        </b-field>

        <b-field
          id="comentario"
          hidden
          class="column is-12"
          label="Comentário"
          :type="{'is-danger': errors.has('comentario')}"
          :message="errors.first('comentario')"
        >
          <b-input
            v-model="correcao.comentario"
            v-validate="'required'"
            name="comentario"
            type="textarea"
          ></b-input>
        </b-field>

        <b-field hidden label="principal?">
          <div class="field">
            <b-switch
              disabled
              true-value="1"
              false-value="0"
              v-model="correcao.principal"
              type="is-success"
            >Success</b-switch>
          </div>
        </b-field>
      </form>
    </article>
    <b-modal :active.sync="isCardModalActive3">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <h1>Adicionar Feedback</h1>

            <b-field label="Feedback">
              <b-input
                maxlength="280"
                type="textarea"
                v-model="redacao.feedback"
                v-validate="'required'"
                name="feedback"
              ></b-input>
            </b-field>

            <button @click="addFeed(redacao.id)" class="button is-primary">adicionar</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import store from "@/store";
import RedacaoService from "@/services/RedacaoService";
export default {
  data() {
    return {
      cargo_id: store.getters.cargo_id,
      isCardModalActive3: false
    };
  },
  name: "correcaoForm",
  props: ["correcao", "buttom", "redacao", "progress"],
  computed: {
    notaFinal() {
      var valor_maximo = 0;
      var total = 0;
      this.redacao.criterios.forEach(criterio => {
        valor_maximo += criterio.nota_maxima * criterio.peso;
        total += criterio.peso * Number(
          this.correcao.notas[criterio.id]
            ? this.correcao.notas[criterio.id]
            : 0
        );
      });
      return (total * this.redacao.nota_maxima) / valor_maximo;
    }
  },
  methods: {
    notas(criterio) {
      var notas = [];
      for (var i = 0; i <= criterio.nota_maxima; i += criterio.nota_escala) {
        notas.push(i);
      }

      return notas;
    },
    validate() {
      document.getElementById("updatebutton").disabled = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("formSubmit", this.correcao, () => {});
        }
      });
      document.getElementById("updatebutton").disabled = false;
    },
    redacaoInfo(id) {
      RedacaoService.Info(id).then(result => {
        this.redacao = result.data;
      });
    },
    addFeed(id) {
      RedacaoService.AddFeedback(this.redacao, id)
        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Feedback adicionado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
          this.$parent.LiberarCorrecao();
          this.$router.push({ name: "redacao"});
        })
        .catch(() => {})
        .finally(() => {});
    }
  }
};
</script>